(function () {
  'use strict';

  /* Mirrors gokwik.liquid's own private waitForGoKwik() (see also
     justpour-product-section.js's copy) — Buy Now needs to wait for the SDK
     independently since that helper isn't exported. */
  function waitForGoKwikSdk() {
    return new Promise(function (resolve) {
      if (window.gokwikSdk) return resolve(window.gokwikSdk);
      var done = false;
      function onReady() {
        if (done) return;
        done = true;
        window.removeEventListener('gokwikLoaded', onReady);
        resolve(window.gokwikSdk || null);
      }
      window.addEventListener('gokwikLoaded', onReady);
      setTimeout(function () {
        if (done) return;
        done = true;
        window.removeEventListener('gokwikLoaded', onReady);
        resolve(window.gokwikSdk || null);
      }, 3000);
    });
  }

  function setButtonBusy(btn, busy) {
    btn.disabled = busy;
    btn.classList.toggle('is-loading', busy);
  }

  function addToCart(variantId, btn) {
    setButtonBusy(btn, true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) {
        return res.ok ? res.json() : res.json().then(function (err) { return Promise.reject(err); });
      })
      .then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'recipe-page-cart' });
        }
      })
      .catch(function () {
        /* silent — the cart drawer not opening is feedback enough that
           something went wrong; nothing destructive to roll back */
      })
      .finally(function () {
        setButtonBusy(btn, false);
      });
  }

  function buyNow(variantId, btn) {
    setButtonBusy(btn, true);
    waitForGoKwikSdk().then(function () {
      if (typeof window.onBuyNowClick === 'function') {
        /* GoKwik's own buy-now API: checks out exactly this variant on its
           own, independent of whatever's already in the cart. */
        window.onBuyNowClick(null, false, [{ id: String(variantId), quantity: 1 }]);
        setButtonBusy(btn, false);
        return;
      }

      /* Fallback for when GoKwik never loaded. */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          setButtonBusy(btn, false);
        });
    });
  }

  function init() {
    document.querySelectorAll('.jp-recipe-page__add-to-cart').forEach(function (btn) {
      if (btn.dataset.jpRecipeBound) return;
      btn.dataset.jpRecipeBound = 'true';
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.jpRecipeVariantId;
        if (variantId) addToCart(variantId, btn);
      });
    });

    document.querySelectorAll('.jp-recipe-page__buy-now').forEach(function (btn) {
      if (btn.dataset.jpRecipeBound) return;
      btn.dataset.jpRecipeBound = 'true';
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.jpRecipeVariantId;
        if (variantId) buyNow(variantId, btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
